import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { APP_LOCALE_STORAGE_KEY, bootstrapStoredLocale, normalizeLocale } from './locale';

bootstrapStoredLocale();

function applyHtmlLocale(language: string | null | undefined) {
  if (typeof document === 'undefined') {
    return;
  }

  const locale = normalizeLocale(language);
  document.documentElement.lang = locale === 'zh'
    ? 'zh-CN'
    : locale === 'ja'
      ? 'ja'
      : locale === 'es'
        ? 'es'
        : locale === 'fr'
          ? 'fr'
          : locale === 'ru'
            ? 'ru'
            : 'en';
  document.documentElement.setAttribute('data-locale', locale);
}

const dictionaries = {
  en: () => import('./dictionaries/en'),
  zh: () => import('./dictionaries/zh'),
  ja: () => import('./dictionaries/ja'),
  es: () => import('./dictionaries/es'),
  fr: () => import('./dictionaries/fr'),
  ru: () => import('./dictionaries/ru'),
};

i18n
  .use({
    type: 'backend' as const,
    read(language: string, _namespace: string, callback: (error: unknown, data: Record<string, string> | false) => void) {
      dictionaries[normalizeLocale(language)]().then(({ default: messages }) => callback(null, messages),
        (error: unknown) => callback(error, false));
    },
  })
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    load: 'languageOnly',
    supportedLngs: ['en', 'zh', 'ja', 'es', 'fr', 'ru'],
    keySeparator: false,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: APP_LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

applyHtmlLocale(i18n.resolvedLanguage ?? i18n.language);
i18n.on('languageChanged', (language) => {
  applyHtmlLocale(language);
});

export default i18n;
